// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash/fp';

import {
  submitTrainingEntry,
  submitEntry,
  submitPxcEntries,
  bulkUpdate,
  updateTrainingEntry,
  updateEntry
} from '../../actions/challengeActions';
import LineUpBuilder from './LineUpBuilder';

type Props = {
  hasUserEntry: boolean,
  contestType: string,
  contestEntryFee: number,
  sport: string
};

class OpenChallenge extends React.Component<Props> {
  props: Props;

  render() {
    const { hasUserEntry, contestType, contestEntryFee, sport, ...restProps } = this.props;
    return <LineUpBuilder {...restProps} />;
  }
}

function mapStateToProps(state) {
  return {
    contestType: state.challenge.competitionName,
    contestEntryFee: state.challenge.reducedCost,
    sport: state.challenge.sportName,
    hasEmbeddedUserEntry: !!state.entry.myEntry.id
  };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: Object) {
  return {
    onSubmit(...args) {
      if (ownProps.isTrainingChallenge) {
        dispatch(submitTrainingEntry(...args));
      } else if (ownProps.isPxcEnabled) {
        dispatch(submitPxcEntries({ ...args }));
      } else {
        dispatch(submitEntry(...args));
      }
    },
    onUpdate() {
      const { entryIdsToUpdate } = ownProps;
      if (entryIdsToUpdate.length > 1) {
        dispatch(bulkUpdate(ownProps.entryIdsToUpdate));
      } else if (ownProps.isTrainingChallenge) {
        dispatch(updateTrainingEntry(entryIdsToUpdate[0]));
      } else {
        dispatch(updateEntry(entryIdsToUpdate[0]));
      }
    }
  };
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  const { hasEmbeddedUserEntry } = stateProps;
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    hasUserEntry: hasEmbeddedUserEntry || get('entryIdsToUpdate.length')(ownProps) > 0
  };
}

const connector = connect(mapStateToProps, mapDispatchToProps, mergeProps);
export default connector(OpenChallenge);
